export const giftLocationSegmentOptionTab = {
    singledDeliveryTab: "singledDelivery",
    multipleAddressTab: "multipleAddress",
    selfPickupTab: "selfPickupTab"
};
